$(document).ready(function () {
  let topSlickSlider = null;

  function initializeSlick() {
    const sliderElement = document.querySelector(
      ".section-video_tv .collage-slider:not(.slick-initialized)",
    );
    if (!sliderElement) return false;

    topSlickSlider = $(sliderElement).slick({
      infinite: false,
      slidesToScroll: 1,
      dots: false,
      arrows: true,
      swipeToSlide: true,
      slidesToShow: 3.3,
      touchThreshold: 100,
      responsive: [
        {
          breakpoint: 1360,
          settings: { slidesToShow: 3.3 },
        },
        {
          breakpoint: 990,
          settings: { slidesToShow: 2.5 },
        },
        {
          breakpoint: 662,
          settings: { slidesToShow: 1.9 },
        },
        {
          breakpoint: 577,
          settings: { slidesToShow: 1.7 },
        },
        {
          breakpoint: 480,
          settings: { slidesToShow: 1.2 },
        },
      ],
    });
    return true;
  }

  // Initialize on page load
  if (!initializeSlick()) {
    // If slick element not found on load, try again after a short delay
    setTimeout(initializeSlick, 100);
  }

  let scrollTimeout;
  window.addEventListener(
    "scroll",
    () => {
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(() => {
        document.querySelectorAll(".section-video_tv").forEach((el) => {
          el.classList.remove("animated_col");
        });
      }, 800);
    },
    { passive: true },
  );

  function destroySlickslider() {
    const sliderElement = document.querySelector(
      ".section-video_tv .collage-slider",
    );
    if (!sliderElement?.classList.contains("slick-initialized")) return;

    if (topSlickSlider && topSlickSlider.length > 0) {
      try {
        topSlickSlider.slick("destroy");
        topSlickSlider = null;
      } catch (e) {
        console.warn("Error destroying slick slider:", e);
      }
    }
  }

  function tvSlickslider() {
    if (!topSlickSlider || topSlickSlider.length === 0) {
      initializeSlick();
      return;
    }
    try {
      topSlickSlider.slick("refresh");
    } catch (e) {
      console.warn("Error refreshing slick slider:", e);
      initializeSlick();
    }
  }

  subscribe("feed-loaded", (e) => {
    // console.log("🚩", e);
    destroySlickslider();
    tvSlickslider();
    fcsgtvsectionHeights();
  });

  function initializeSwiper() {
    let marqueeSlider = document.querySelector(".swiper-wrapperss");
    if (!marqueeSlider) return; // Guard against null element

    let mainTicker = new Flickity(".swiper-wrapperss", {
      accessibility: true,
      resize: true,
      wrapAround: true,
      prevNextButtons: false,
      pageDots: false,
      percentPosition: true,
      setGallerySize: true,
      adaptiveHeight: true,
    });

    // Initial position
    mainTicker.x = 0;
    let requestId;
    let speed = 0.6; // Normal speed
    let isHovering = false; // Track hover state

    // Start the marquee animation
    play();

    // Main function that 'plays' the marquee.
    function play() {
      // Adjust speed based on hover state
      const currentSpeed = isHovering ? 0.15 : speed;

      // Update the position
      mainTicker.x -= currentSpeed;

      // Settle position into the slider
      mainTicker.settle(mainTicker.x);

      // Continue the animation loop
      requestId = window.requestAnimationFrame(play);
    }

    // Function to handle hover
    function onHover() {
      isHovering = true; // Set hover state to true
    }

    // Function to handle hover out
    function onHoverOut() {
      isHovering = false; // Reset hover state
    }

    // Add event listeners for hover
    marqueeSlider.addEventListener("mouseenter", onHover);
    marqueeSlider.addEventListener("mouseleave", onHoverOut);
  }

  /* end */

  fcsgtvsectionHeights();
  function heightDelay() {
    // Reinitialize GSAP animations after slide change
    setTimeout(() => {
      fcsgtvsectionHeights();
    }, 0); // Slight delay to ensure Slick has updated
  }
  function fcsgtvsectionHeights() {
    // Batch DOM reads first (avoid layout thrashing)
    const mainSection = document.querySelector(".tv_section");
    const pageDiv = mainSection?.querySelector(".page-width");

    if (!mainSection || !pageDiv) return;

    // Read all properties before writing
    const fcsgHeight = mainSection.offsetHeight;
    const fcsgDiv = pageDiv.offsetHeight;
    const totleHeight = fcsgHeight - fcsgDiv;

    // Now batch DOM writes
    document.querySelectorAll(".collage-wrapper").forEach((el) => {
      el.style.marginTop = -totleHeight + "px";
    });
  }
});
